let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("3TPNO")]).then(() => parcelRequire('1Tm7l'));